import forEach from "lodash/forEach";
import uniq from "lodash/uniq";
import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { useCallback } from "react";

import { useResponseErrors } from "../helpers/use_response_errors";

type ErrorsGrowlOptions = {
  display?: "firstOne" | "onePerType" | "all";
  unique?: boolean;
};

export const useErrorsGrowl = () => {
  const { showGrowl } = useGrowlStoreActions();
  const { getSingleErrorByType, getAllErrorsByType, getFirstError } = useResponseErrors();

  return useCallback(
    (errors: any, { display = "onePerType", unique = false }: ErrorsGrowlOptions = {}) => {
      const showMessages = (messages: string[]) =>
        forEach(unique ? uniq(messages) : messages, (message) => showGrowl({ message, kind: "error" }));

      if (display === "firstOne") {
        const errorMessage = getFirstError(errors);
        errorMessage && showGrowl({ message: errorMessage, kind: "error" });
        return;
      }

      if (display === "onePerType") {
        showMessages(Object.values(getSingleErrorByType(errors)));
        return;
      }

      if (display === "all") {
        showMessages(Object.values(getAllErrorsByType(errors)).flat());
      }
    },
    [getAllErrorsByType, getFirstError, getSingleErrorByType, showGrowl]
  );
};
